import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfter({ before, after }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      role="slider"
      aria-label="Confronto prima e dopo la ristrutturazione"
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(0, p - 5));
        if (e.key === "ArrowRight") setPos((p) => Math.min(100, p + 5));
      }}
      onPointerDown={(e) => {
        ref.current.setPointerCapture(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => {
        if (e.buttons === 1) update(e.clientX);
      }}
      className="relative aspect-[4/3] w-full cursor-ew-resize touch-none select-none overflow-hidden rounded-2xl sm:aspect-[16/9]"
    >
      <img src={after} alt="Cucina dopo la ristrutturazione" className="absolute inset-0 h-full w-full object-cover" />
      <div
        className="absolute inset-0"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img src={before} alt="Cucina prima della ristrutturazione" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <span className="absolute left-4 top-4 rounded-full bg-[#161514]/80 px-3 py-1 font-mono text-xs uppercase tracking-[0.2em] text-[#FAF8F5] backdrop-blur">
        Prima
      </span>
      <span className="absolute right-4 top-4 rounded-full bg-[#C85A32]/90 px-3 py-1 font-mono text-xs uppercase tracking-[0.2em] text-[#FAF8F5] backdrop-blur">
        Dopo
      </span>
      <div
        data-testid="before-after-handle"
        className="absolute inset-y-0 z-10 w-[2px] bg-[#FAF8F5]"
        style={{ left: `${pos}%` }}
      >
        <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#FAF8F5] text-[#161514] shadow-xl">
          <ChevronsLeftRight size={18} />
        </span>
      </div>
    </div>
  );
}
